// import { useEffect } from 'react'

import Scs from '../../assets/scs.png'
import Teleassist from '../../assets/TeleAssistance SCSInformatique.exe'

import './navbar.sass'

const Navbar = () => {
    // function spawnRod() {
    //     const rod = document.querySelectorAll('.navbar__rod')
    //     console.log(rod);
    //     window.addEventListener('scroll', function(e){
    //         const windowTop = window.scrollY
    //         if(windowTop >= 100){
    //             rod.style.opacity = '1'
    //         } else if (windowTop <= 99){
    //             rod.style.opacity = '0'
    //             // rod.style.transition = 'opacity 1000ms ease-in'
    //         }
    //     })
    // }
    // window.addEventListener('scroll', () => {
    //     spawnRod()
    // })
    return (
        <header className='navbar'>
            <nav className='navbar__container'>
                <div className='navbar__container__left'>
                    <img className='navbar__container__left__img' src={Scs} alt="" />
                    <a className='navbar__container__left__link' href='#presentation'>SCSInformatique</a>
                </div>
                <div className='navbar__container__middle'>
                    <a className='navbar__container__middle__link' href='#presentation'>Accueil</a>
                    <a className='navbar__container__middle__link' href='#services'>Services</a>
                    <a className='navbar__container__middle__link' href='#about'>À propos</a>
                    <a className='navbar__container__middle__link' href='#contact'>Nous contacter</a>
                </div>
                <a className='navbar__container__right' href={Teleassist} download>TéléAssistance</a>
            </nav>
            <div className='navbar__rod'></div>
        </header>
    )
}

export default Navbar